export enum ExecutionFramework {
    spark3 = 'spark3',
    python3 = 'python3',
}
